import React from 'react'
import {Routes,Route} from 'react-router-dom';
import Account from './Account';

const AccountView = (props:any) => {
  const userHasChangePassword = props.data;
  const setUserHasChangePassword = props.onChange;

  return (
     <Routes>
       <Route path="*" element={<Account data={userHasChangePassword} onChange={setUserHasChangePassword}/>} />
     </Routes>
  )
}

export default AccountView

export {default as Login} from './Login';
export {default as ForgotPassword} from './ForgotPassword';
export {default as ChangePassword} from './ChangePassword';
